import { FormControl, FormControlLabel, Button, FormLabel, Grid, Radio, RadioGroup, Chip, Typography } from '@mui/material'
import { makeStyles } from "@mui/styles";
import { useField, Field, useFormikContext } from 'formik';
import React from 'react'
import BackupIcon from "@mui/icons-material/Backup";
import Dropzone from "react-dropzone";
import { useSnackbar } from "notistack";
import { snackAction } from '../../../../components/CustomSnakbar';
import './styless.css'
import CustomSnackbarCollapse from '../../../../components/CustomSnackbarCollapse';
import { useSelector } from 'react-redux';
//TODO: llevar los estilos a un css-js para limpiarlo de aca

const SelectDocument = (props) => {
  const { setFieldValue, values } = useFormikContext();
  const { enqueueSnackbar } = useSnackbar();
  const xmlLoaded = useSelector(store => store.documentXml.xmlLoaded)

  const DROPZONE_TYPE = {
    INSURANCE: 'insurances',
    DOCUMENT: 'document',
    OTHER_SUPPORTS: 'otherSupports',
  }

  const onDrop = (cfiles, type, isOnlyOne = false) => {
    let filesDuplicates = [];
    if (cfiles && Array.isArray(cfiles) && cfiles.length > 0) {
      let currentDocument = [...values[type]];
      cfiles.forEach(x => {
        if ((Array.isArray(values.insurances) && values.insurances.some(item => item.name === x.name)) ||
          (Array.isArray(values.otherSupports) && values.otherSupports.some(item => item.name === x.name)) ||
          (Array.isArray(values.document) && values.document.some(item => item.name === x.name))) {
          filesDuplicates.push(x.name)
        } else {
          if (isOnlyOne) {
            currentDocument = [];
            currentDocument.push(x);
          }
          else
            currentDocument.push(x)
        }
      })
      setFieldValue(type, currentDocument)
    }
    if (filesDuplicates.length > 0)
      enqueueSnackbar(``, {
        action: snackAction, autoHideDuration: 3000, content:
          <CustomSnackbarCollapse
            key="Error-General" label="Un archivo seleccionado ya se encuentra adjunto" errorMessage={
              <React.Fragment>
                <Typography gutterBottom>Los siguientes archivos no se adjuntaron</Typography>
                {filesDuplicates.map(fd => { return (<Chip label={fd} variant="outlined" />) })}
              </React.Fragment>
            }
          />,
      });
  }

  const handleDelete = (cfiles, type) => {
    let currentDocument = [...values[type]];
    currentDocument.splice(currentDocument.indexOf(cfiles), 1)
    setFieldValue(type, currentDocument)
  }

  const removeAll = (e, type) => {
    e.stopPropagation()
    setFieldValue(type, [])
  }

    const getDocumentLabel = (id) => {
        switch (id) {
            case 2:
                return "Factura Anticipo";
            case 1:
                return "Factura";
            default:
                return "Nota Crédito";
        }
    };
  
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} marginTop={2}>
        <div /* className="my-3" */ className="containerDrop">
          <div className="labelDrop">{getDocumentLabel(values.documentTypeId)}</div>
                  {/*<div className="labelDrop">{values.documentTypeId === 2 ? "Factura" : "Nota Credito"}</div>*/}
          <Dropzone onDrop={(cfiles) => onDrop(cfiles, DROPZONE_TYPE.DOCUMENT, true)} maxFiles={1} accept="application/pdf, image/jpeg, image/tiff">
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps({ className: "dropzone" })}>
                  <input {...getInputProps()} />
                  {values.document &&
                    Array.isArray(values.document) &&
                    values.document.length ? (
                    <div className="selected-file">
                      {values.document.map((file) => {
                        return (
                          <Chip label={file.name} variant="outlined" onDelete={() => handleDelete(file, DROPZONE_TYPE.DOCUMENT)} />
                        )
                      })}
                    </div>
                  ) : (
                    <>
                      <div style={{ color: "orange", fontWeight: "bold", fontSize: "15px" }}>
                           Adjunte {getDocumentLabel(values.documentTypeId)} en formato .pdf, .jpg, .tif
                                                {/*  Adjunte {values.documentTypeId === 2 ? "Factura Anticipo" : "Nota Crédito"} en formato .pdf, .jpg, .tif*/}
                      </div>
                      <BackupIcon />
                      <p>
                        Arrastra los archivos aquí o <u> explora</u><br /><br />
                      </p>
                    </>
                  )}
                </div>
                <aside className="selected-file-wrapper"></aside>
              </section>
            )}
          </Dropzone>
        </div>
      </Grid>
      {
        values.documentTypeId === 2 && (
          <Grid item xs={12} marginTop={2}>
            <div /* className="my-3" */ className="containerDrop">
              <div className="labelDrop">Polizas / Garantias</div>
              <Dropzone onDrop={(cfiles) => onDrop(cfiles, DROPZONE_TYPE.INSURANCE)}>
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps({ className: "dropzone" })}>
                      <input {...getInputProps()} />
                      {values.insurances &&
                        Array.isArray(values.insurances) &&
                        values.insurances.length ? (
                        <>
                          <div className="selected-file">
                            {values.insurances.map((file) => {
                              return (
                                <span className="selected-file-item">
                                  <Chip label={file.name} variant="outlined" onDelete={() => handleDelete(file, DROPZONE_TYPE.INSURANCE)} />
                                </span>
                              )
                            })}
                            <div>
                              <p style={{ color: "orange", fontWeight: "bold", fontSize: "15px", marginLeft: "200px", marginRight: "200px" }}>
                                Puede agregar mas archivos "arrastrando" desde su explorador de archivos
                              </p>
                            </div>
                          </div>
                          <div className="delete-all-file-items">
                            {values.insurances.length > 1 &&
                              <Chip label="Borrar adjuntos" onClick={(e) => removeAll(e, DROPZONE_TYPE.INSURANCE)} />
                            }
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ color: "orange", fontWeight: "bold", fontSize: "15px" }}>
                            Adjunte Polizas/Fianzas requeridas para avalar el Pago del Anticipo
                          </div>
                          <BackupIcon />
                          <p>
                            Arrastra los archivos aquí o <u> explora</u><br /><br />
                          </p>
                        </>
                      )}
                    </div>
                    <aside className="selected-file-wrapper"></aside>
                  </section>
                )}
              </Dropzone>
            </div>
          </Grid>

        )
      }

      {!xmlLoaded ?
        <Grid item xs={12}>
          <div /* className="my-3" */ className="containerDrop">
            <div className="labelDrop">Otros soportes</div>
            <Dropzone onDrop={(cfiles) => onDrop(cfiles, DROPZONE_TYPE.OTHER_SUPPORTS)}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps({ className: "dropzone" })}>

                    <input {...getInputProps()} />
                    {values.otherSupports &&
                      Array.isArray(values.otherSupports) &&
                      values.otherSupports.length ? (
                      <>
                        <div className="selected-file">
                          {values.otherSupports.map((file) => {
                            return (
                              <span className="selected-file-item">
                                <Chip label={file.name} variant="outlined" onDelete={() => handleDelete(file, DROPZONE_TYPE.OTHER_SUPPORTS)} />
                              </span>
                            )
                          })}
                          <div>
                            <p style={{ color: "orange", fontWeight: "bold", fontSize: "15px", marginLeft: "200px", marginRight: "200px" }}>
                              Puede agregar mas archivos "arrastrando" desde su explorador de archivos
                            </p>
                          </div>
                        </div>
                        <div className="delete-all-file-items">
                          {values.otherSupports.length > 1 &&
                            <Chip label="Borrar adjuntos" onClick={(e) => removeAll(e, DROPZONE_TYPE.OTHER_SUPPORTS)} />
                          }
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ color: "orange", fontWeight: "bold", fontSize: "15px" }}>
                          Adjunte Otros Soportes asociados.<br />
                          En el caso que corresponda es mandatorio adjuntar archivo XML
                        </div>
                        <BackupIcon />
                        <p>
                          Arrastra los archivos aquí o <u> explora</u><br /><br />
                        </p>
                      </>
                    )}
                  </div>
                  <aside className="selected-file-wrapper"></aside>
                </section>
              )}
            </Dropzone>
          </div>
        </Grid>
        :
        <Grid item xs={12}>
          <div /* className="my-3" */ className="containerDrop">
            <div className="labelDrop">Otros soportes</div>
            <Dropzone onDrop={(cfiles) => onDrop(cfiles, 'otherSupportsFiles')}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps({ className: "dropzone" })}>

                    <input {...getInputProps()} />
                    {values.otherSupportsFiles &&
                      Array.isArray(values.otherSupportsFiles) &&
                      values.otherSupportsFiles.length ? (
                      <>
                        <div className="selected-file">
                          {values.otherSupportsFiles.map((file) => {
                            return (
                              <span className="selected-file-item">
                                <Chip label={file.name} variant="outlined" onDelete={() => handleDelete(file, 'otherSupportsFiles')} />
                              </span>
                            )
                          })}
                          <div>
                            <p style={{ color: "orange", fontWeight: "bold", fontSize: "15px", marginLeft: "200px", marginRight: "200px" }}>
                              Puede agregar mas archivos "arrastrando" desde su explorador de archivos
                            </p>
                          </div>
                        </div>
                        <div className="delete-all-file-items">
                          {values.otherSupportsFiles.length > 1 &&
                            <Chip label="Borrar adjuntos" onClick={(e) => removeAll(e, 'otherSupportsFiles')} />
                          }
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ color: "orange", fontWeight: "bold", fontSize: "15px" }}>
                          Adjunte Otros Soportes asociados.<br />
                        </div>
                        <BackupIcon />
                        <p>
                          Arrastra los archivos aquí o <u> explora</u><br /><br />
                        </p>
                      </>
                    )}
                  </div>
                  <aside className="selected-file-wrapper"></aside>
                </section>
              )}
            </Dropzone>
          </div>
        </Grid>
      }
    </Grid>

  )
}

export default SelectDocument